module.exports = __webpack_public_path__ + "img/pt.0d1db79e.png";